exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-build-version[data-v-65f1d51e]{position:absolute;bottom:1rem;right:1.5rem;color:var(--fts-gray-4);font-size:.75rem}", ""]);

// exports
